<template>
  <el-dialog
    v-if="dialogVisible"
    :visible.sync="dialogVisible"
    :title="getTitle"
    width="80%"
    append-to-body
  >
    <div class="dialog-content">
      <el-form :model="dialogData" :rules="dialogRules" ref="dialogForm">
        <el-row :gutter="24">
          <el-col :span="8">
            <el-form-item label="货物类型" prop="cargoType" label-width="100px">
              <!--  -->
              <search-table
                ref="searchTable"
                v-model="dialogData.cargoType"
                searchType="product"
                :isMultiple="true"
                :currentValue="dialogData.cargoTypeName"
                :checkRowKeys="[dialogData.cargoType] || []"
                :extraData="{
                  parentProductStatus: 'ZT03',
                  selectCompanyCode: userInfo.companyCode,
                  companyCode: userInfo.companyCode,
                  adminFlag: userInfo.adminFlag,
                }"
                @input="changeCargoTypeHandler"
              ></search-table>
              <!-- <el-select
                :currentValue="feeInfo.payableInvoiceCreatePersonName"
                :checkRowKeys="feeInfo.payableInvoiceCreatePersonNos || []"
                v-model="dialogData.cargoType"
                placeholder="请选择货物类型"
                class="unit_width"
                @change="activeChange"
              >
                <el-option
                  v-for="(item, index) in goodsTypeList"
                  :key="index"
                  :label="item.label"
                  :value="item.value"
                >
                </el-option>
              </el-select> -->
            </el-form-item>
          </el-col>
          <el-col :span="8">
            <el-form-item label="货物品类" prop="cargoCategory" label-width="100px">
              <search-table
                ref="searchTable"
                v-model="dialogData.cargoCategory"
                searchType="goodsDetail"
                :isMultiple="true"
                :currentValue="dialogData.cargoCategoryName"
                :checkRowKeys="[dialogData.cargoCategory] || []"
                :extraData="{
                  parentProductStatus: 'ZT03',
                  productParentCodes: [dialogData.cargoType],
                }"
                @input="changeCargoCategoryHandler"
              ></search-table>

              <!-- <search-table
                :value="dialogData.cargoCategory"
                searchType="product"
                :isMultiple="true"
                :currentValue="dialogData.cargoCategory"
                @input="selectCategoryHandler"
                placeholder="请选择货物品类"
              >
              </search-table> -->
              <!-- <el-select
                v-model="dialogData.cargoCategory"
                placeholder="请选择货物品类"
                class="unit_width"
                @change="cargoCategoryChange"
              >
                <el-option
                  v-for="(item, index) in goodsCategoryList"
                  :key="index"
                  :label="item.label"
                  :value="item.value"
                >
                </el-option>
              </el-select> -->
            </el-form-item>
          </el-col>
          <el-col :span="8">
            <el-form-item label="货物规格编码" prop="cargoSpecificationsModel" label-width="100px">
              <el-input
                v-model="dialogData.cargoSpecificationsModel"
                placeholder="请输入货物规格编码"
              ></el-input>
            </el-form-item>
          </el-col>
        </el-row>
        <el-row :gutter="24">
          <el-col :span="8">
            <el-form-item label="重量/数量" prop="weight" label-width="100px">
              <input-number-ad
                v-model="dialogData.weight"
                :controls="false"
                :max="99999999999999"
                :min="0"
                :precision="2"
                class="inputWidth"
                maxlength="99999999999999"
              ></input-number-ad>
            </el-form-item>
          </el-col>
          <el-col :span="8">
            <el-form-item label="单位" prop="weightUnit" label-width="100px">
              <el-input
                v-model="dialogData.weightUnit"
                placeholder="请输入单位"
                disabled
              ></el-input>
            </el-form-item>
          </el-col>
          <el-col :span="8">
            <el-form-item label="备注" prop="remarks" label-width="100px">
              <el-input v-model="dialogData.remarks"></el-input>
            </el-form-item>
          </el-col>
        </el-row>
      </el-form>
    </div>
    <template #footer>
      <span class="dialog-footer">
        <el-button @click="cancelHandler" size="small">取消</el-button>
        <el-button type="primary" @click="confirmHandler" size="small">确认</el-button>
      </span>
    </template>
  </el-dialog>
</template>

<script>
  import { dialogRules } from './rules.js';
  import ProjectCommonMixin from '@/pages/park/warehouse/project/mixins/projectCommonMixin';
  import inputNumberAd from '@/components/form-item/input-number-advance';
  import goodsApi from '@/api/masterData/goods.js';
  // import BASE_API from '@/api/dataBase.js';
  export default {
    name: 'EditFreightDialog',
    mixins: [ProjectCommonMixin],
    components: { inputNumberAd },
    props: {},
    data() {
      return {
        dialogVisible: false,
        dialogRules,
        dialogData: {
          // artcleName: null,
          cargoType: null,
          cargoTypeName: null,
          cargoCategory: null,
          cargoCategoryName: null,
          cargoSpecificationsModel: null,
          weight: 0,
          weightUnit: null,
          weightUnitName: null,
          remarks: null,
        },
        isEditModal: false,
        grossWeightUnitList: [], //重量
        goodsTypeList: [], // 货物品类
        goodsCategoryAll: [], //所有品类
        goodsCategoryList: [], // 货物品类
      };
    },
    mounted() {
      this.getGoodsParentApi(); // 获取商品大类
      this.getGoodsCategoryAll();
    },
    computed: {
      getTitle() {
        if (this.isEditModal) {
          return '编辑货物';
        } else {
          return '新建货物';
        }
      },
    },
    methods: {
      changeCargoTypeHandler(val) {
        const rowData = val && Array.isArray(val) && val.length ? val[0] : {};
        console.log('选择', rowData);
        this.dialogData.cargoType = rowData.parentProductNo;
        this.dialogData.cargoTypeName = rowData.productChName;
        this.dialogData.cargoCategory = '';
        this.dialogData.cargoCategoryName = '';
        this.dialogData.cargoSpecificationsModel = '';
        // 0512 与BA确认取货物类型单位
        this.dialogData.weightUnit = rowData.basicUnitName;
        this.dialogData.weightUnitName = rowData.basicUnitName;
      },
      changeCargoCategoryHandler(val) {
        const rowData = val && Array.isArray(val) && val.length ? val[0] : {};
        console.log(rowData);
        this.dialogData.cargoCategory = rowData.productDetailCode;
        this.dialogData.cargoCategoryName = rowData.productChName;
        this.dialogData.cargoSpecificationsModel = rowData.detailProductModel;
        // this.dialogData.weightUnit = rowData.basicUnit;
        // this.dialogData.weightUnitName = rowData.basicUnitName;
      },
      async getGoodsParentApi() {
        const { data } = await this.$axios.post(goodsApi.PRODUCT_TYPE, {
          parentProductStatus: 'ZT03',
          selectCompanyCode: this.userInfo.companyCode,
          adminFlag: this.userInfo.adminFlag,
        });
        if (data.code == 0) {
          // console.log(data.data, '1111');
          this.goodsTypeList = data.data?.map((item) => {
            return {
              basicUnitName: item.basicUnitName,
              parentProductNo: item.parentProductNo,
              value: item.parentProductNo,
              label: item.productChName,
            };
          });
        } else {
          console.error('获取商品大类数据失败');
        }
      },
      async getGoodsCategoryAll() {
        const { data } = await this.$axios.post(goodsApi.GOODS_LIST_BY_TYPE);
        if (data.code == 0) {
          this.goodsCategoryAll = data.data?.map((item) => {
            return {
              value: item.productDetailCode,
              label: item.productChName,
            };
          });
          console.log(this.goodsCategoryAll, '全部的货物品类');
        } else {
          console.error('获取货物品类数据失败');
        }
      },
      // 根据货物类型查询货物品类
      async getGoodsCategoryApi() {
        delete this.goodsTypeList.basicUnitName;
        const productParentCodes = this.goodsTypeList
          .filter((item) => this.dialogData.cargoType.includes(item.value))
          .map((item) => item.parentProductNo);
        const { data } = await this.$axios.post(goodsApi.GOODS_LIST_BY_TYPE, {
          parentProductStatus: 'ZT03',
          productParentCodes,
        });
        if (data.code == 0) {
          // console.log(data.data, 'data.data');
          this.goodsCategoryList = data.data?.map((item) => {
            return {
              value: item.productDetailCode,
              label: item.productChName,
              cargoSpecificationsModel: item.detailProductModel,
            };
          });
          // console.log(this.goodsCategoryList, 'this.goodsCategoryList');
        } else {
          console.error('获取货物类型数据失败');
        }
      },
      getUnitName(type, value) {
        let res = '';
        let item;
        let list = [];
        if (type == 'Type') {
          list = this.goodsTypeList;
          // console.log(this.goodsTypeList, 'this.goodsTypeList');
        } else if (type == 'Category') {
          // this.getGoodsCategoryApi()
          list = this.goodsCategoryAll;
          console.log(list, 'this.goodsCategoryAll');
        }
        item = list.find((item) => item.value == value);
        if (item) {
          res = item.label;
        }
        return res;
      },
      activeChange(val) {
        // console.log(val, 'val');
        this.dialogData.cargoCategory = null;
        this.dialogData.weightUnit = null;
        this.dialogData.cargoType = val;
        this.goodsTypeList.forEach((item) => {
          if (item.value == val) {
            this.dialogData.weightUnit = item.basicUnitName;
            this.dialogData.cargoTypeName = item.label;
          }
          // console.log(item);
        });
        this.getGoodsCategoryApi();
        this.$emit('sendData', this.goodsTypeList, this.goodsCategoryList);
      },
      cargoCategoryChange(val) {
        const item = this.goodsCategoryList.find((item) => item.value == val);
        this.dialogData.cargoCategoryName = item.label;
        this.dialogData.cargoSpecificationsModel = item.cargoSpecificationsModel;
        console.log('item', item);
      },
      openModal(rowData = {}) {
        this.dialogVisible = true;
        if (Object.keys(rowData).length) {
          this.isEditModal = true;
          this.dialogData = rowData;
          this.getGoodsCategoryApi();
        } else {
          this.isEditModal = false;
          for (let key in this.dialogData) {
            this.dialogData[key] = null;
          }
        }
      },
      cancelHandler() {
        for (let key in this.dialogData) {
          this.dialogData[key] = null;
        }
        this.dialogVisible = false;
        // this.dialogData = {};
        // this.$refs.dialogForm.resetFields();
      },
      confirmHandler() {
        this.$refs.dialogForm.validate(async (valid) => {
          const data = { ...this.dialogData };
          if (valid) {
            this.$emit('confirmHandler', data, this.isEditModal);
            this.cancelHandler();
          }
        });
      },
    },
  };
</script>

<style lang="scss" scoped>
  .unit_width {
    width: 280px;
  }
</style>
